import { useSelector } from "react-redux";

// Read-only - the actual fetch is triggered once from a single call site
// (useLoadIncidentTypes, mounted in CasesRoutes.jsx), not from here. This
// hook is used by several components at once (one per case card, plus a
// few detail screens), so it must never be the thing that dispatches.
const useIncidentTypes = () => {
  const { data, isLoading } = useSelector(s => s.incidentTypes);
  return { data, isLoading };
};

export default useIncidentTypes;
